import React from "react";
import { graphql } from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";

const CampaignTitleContentImage = ({ title, richContent, image, reverse }) => {
  return (
    <section className="campaign-title-content-image">
      <div className={`campaign-title-content-image__inner${reverse ? ' campaign-title-content-image__reverse' : ''}`}>
        <div className="campaign-title-content-image__content" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
        </div>

        <div className="campaign-title-content-image__image" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
          {image && <Asset asset={image} />}
        </div>
      </div>
    </section>
  )
}

export default CampaignTitleContentImage

export const query = graphql`
  fragment CampaignTitleContentImageProps on DatoCmsCampaignTitleContentImage {
    ... on DatoCmsCampaignTitleContentImage {
      id
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
      reverse
    }
  }
`
